// utils/filterSerializer.js
/**
 * Encode filters  string  (URL‑safe, reversible)
 */
export function encodeFilters(filtersObj = {}) {
  if (!filtersObj || !Object.keys(filtersObj).length) return "";
  return btoa(
    // base‑64
    encodeURIComponent(
      // escape unicode
      JSON.stringify(filtersObj)
    )
  );
}

/**
 * Decode string  filters object
 */
export function decodeFilters(encoded = "") {
  if (!encoded) return {};
  try {
    return JSON.parse(decodeURIComponent(atob(encoded)));
  } catch {
    return {}; // bad data?  ignore & fall back to defaults
  }
}
